import type { PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';
import type { FC } from 'react';

export const IconPlay: FC<PropsWithClassProps> = ({ classProps }) => {
  return (
    <svg width="16" height="19" viewBox="0 0 16 19" xmlns="http://www.w3.org/2000/svg" className={classProps?.root}>
      <path
        d="M14.9203 8.04887L2.54531 0.732857C1.53984 0.138717 0 0.715279 0 2.18481V16.8133C0 18.1317 1.43086 18.9262 2.54531 18.2653L14.9203 10.9528C16.0242 10.3024 16.0277 8.69926 14.9203 8.04887V8.04887Z"
        fill="currentColor"
      />
    </svg>
  );
};
